import React, { useState } from "react";

/**
 * Подсказка на странице входа о рекомендуемом браузере.
 * Показываем всегда: iOS (iPhone/iPad) -> Safari, Android -> Chrome.
 * Если открыт НЕ нужный браузер — усиленное предупреждение.
 * PWA корректно работает только в Chrome (Android) и Safari (iPhone/iPad).
 */
const detectTip = () => {
  if (typeof window === "undefined" || !window.navigator) return null;
  const ua = window.navigator.userAgent || "";

  const isIOS =
    /iP(hone|ad|[o]d)/.test(ua) ||
    (/Macintosh/.test(ua) &&
      !!window.navigator.maxTouchPoints &&
      window.navigator.maxTouchPoints > 1);

  const isAndroid = /Android/.test(ua);

  if (isIOS) {
    const isRealSafari = !/CriOS|FxiOS|EdgiOS|OPiOS|DuckDuckGo|Focus|Brave/.test(ua);
    return {
      emoji: "📱",
      title: "Рекомендуем Safari",
      body: "На iPhone/iPad войдите в браузер Safari для корректной работы.",
      warn: !isRealSafari,
    };
  }

  if (isAndroid) {
    const isRealChrome =
      /Chrome\//.test(ua) &&
      !/SamsungBrowser|Firefox\/|OPR\/|EdgA|UBrowser|Quark|XiaoMi|UCBrowser|Baidu/.test(ua);
    return {
      emoji: "🤖",
      title: "Рекомендуем Chrome",
      body: "На Android откройте приложение в браузере Chrome для корректной работы.",
      warn: !isRealChrome,
    };
  }

  // Десктоп или неизвестное устройство — подсказку не показываем
  return null;
};

const BrowserAdvice = () => {
  const [tip] = useState(detectTip);
  if (!tip) return null;

  return (
    <div
      className={`mb-5 rounded-2xl border p-4 text-left ${
        tip.warn
          ? "border-amber-300 dark:border-amber-600/50 bg-amber-50 dark:bg-amber-900/20"
          : "border-indigo-100 dark:border-indigo-800/30 bg-indigo-50/60 dark:bg-indigo-900/10"
      }`}
    >
      <div className="flex items-start gap-2">
        <span className="text-lg leading-none">{tip.emoji}</span>
        <div>
          <p
            className={`text-sm font-bold mb-0.5 ${
              tip.warn
                ? "text-amber-700 dark:text-amber-300"
                : "text-indigo-600 dark:text-indigo-300"
            }`}
          >
            {tip.title}
          </p>
          <p
            className={`text-xs leading-relaxed ${
              tip.warn
                ? "text-amber-800/90 dark:text-amber-200/80"
                : "text-indigo-700/80 dark:text-indigo-200/70"
            }`}
          >
            {tip.body}
          </p>
        </div>
      </div>
    </div>
  );
};

export default BrowserAdvice;
